<template>
  <div class="layout-builder-layout-placeholder-timeline">
    <div
      v-for="i in PLACEHOLDER_SAMPLES"
      :key="i"
      class="layout-builder-layout-placeholder-timeline-row"
    >
      <div class="layout-builder-layout-placeholder-timeline-row-column-left">
        <div class="layout-builder-layout-placeholder-timeline-row-column-left-line" />
      </div>
      <div class="layout-builder-layout-placeholder-timeline-row-delimiter">
        <div class="layout-builder-layout-placeholder-timeline-row-delimiter-line" />
        <div class="layout-builder-layout-placeholder-timeline-row-delimiter-circle" />
        <div class="layout-builder-layout-placeholder-timeline-row-delimiter-line" />
      </div>
      <div class="layout-builder-layout-placeholder-timeline-row-column-right">
        <div class="layout-builder-layout-placeholder-timeline-row-column-right-line-top" />
        <div
          v-if="i % 2 === 0"
          class="layout-builder-layout-placeholder-timeline-row-column-right-line-bottom"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'LayoutBuilderLayoutPlaceholderTimeline',
  setup() {
    const PLACEHOLDER_SAMPLES = 50;

    return {
      PLACEHOLDER_SAMPLES,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../../styles/index";

.layout-builder-layout-placeholder-timeline {
  $root: &;

  @include placeholder;

   &-row {
    align-items: flex-start;

    &-column-left {
      width: 3.1875rem;

      &-line {
        @include placeholder-line-secondary;
      }
    }

    &-delimiter {
      width: 2.75rem;

      &-circle {
        @include placeholder-circle;

        width: var(--s-3);
        height: var(--s-3);
        margin-left: 0.9375rem;
      }

      &-line {
        width: 1px;
        background: var(--or-c-surface-2);
        margin-left: 1.1875rem;
        height: 10px;
      }
    }

    &-column-right {
      flex: 1;

      &-line-top {
        @include placeholder-line-secondary;
      }

      &-line-bottom {
        @include placeholder-line-primary;

        margin-top: var(--s-3);
        width: 3.75rem;
      }
    }

    &:first-child {
      align-items: center;

      #{$root}-row-column-left-line,
      #{$root}-row-column-right-line-top {
        margin-top: 0;
      }

      #{$root}-row-delimiter-circle {
        width: var(--s-6);
        height: var(--s-6);
        margin-left: var(--s-2);
      }

      #{$root}-row-delimiter-line {
        display: none;
      }
    }

    &:nth-child(even) {
      #{$root}-row-column-left-line,
      #{$root}-row-column-right-line-top {
        margin-top: 3rem;
      }

      #{$root}-row-delimiter-line:first-child {
        height: 3.3125rem;
      }
      #{$root}-row-delimiter-line:last-child {
        height: 5.125rem;
      }
    }

    &:nth-child(odd) {
      #{$root}-row-delimiter-line {
        height: 0.3125rem;
      }
    }
   }
}
</style>
